import loadable from '@loadable/component';

export const WallpaperSiteWrapper = loadable(
  () => import(/* webpackChunkName: "wallpaper-site" */ './WallpaperSiteWrapper'),
);
